import { render, staticRenderFns } from "./examinationlist.vue?vue&type=template&id=21e42e8d&"
import script from "./examinationlist.vue?vue&type=script&lang=js&"
export * from "./examinationlist.vue?vue&type=script&lang=js&"
import style0 from "./examinationlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports